<template>
    <div class="contact-form border rounded p-3 mb-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="mb-0">
                <span v-if="contact.isVipps" class="badge bg-vipps me-2">Vipps</span>
                <span v-else-if="contact.isRequired" class="badge bg-warning me-2">{{ $t('Påkrevd') }}</span>
                {{ $t('Kontaktperson') }} {{ index + 1 }}
            </h6>
            <button
                v-if="!contact.isVipps && !contact.isRequired"
                type="button"
                class="btn btn-sm btn-outline-danger"
                @click="$emit('remove')"
            >
                <i class="fa fa-trash"></i>
            </button>
        </div>

        <div class="row">
            <div class="form-group">
                <label>{{ $t("Mobilnummer") }}</label>
                <input
                    :value="contact.mobile"
                    @input="updateField('mobile', $event.target.value)"
                    type="tel"
                    class="form-control input"
                    :readonly="contact.isReadonly"
                />
            </div>

            <div class="form-group">
                <label>{{ $t("Fornavn") }}</label>
                <input
                    :value="contact.firstName"
                    @input="updateField('firstName', $event.target.value)"
                    type="text"
                    class="form-control input"
                    :readonly="contact.isReadonly"
                />
            </div>
            <div class="form-group">
                <label>{{ $t("Etternavn") }}</label>
                <input
                    :value="contact.lastName"
                    @input="updateField('lastName', $event.target.value)"
                    type="text"
                    class="form-control input"
                    :readonly="contact.isReadonly"
                />
            </div>

            <div class="form-group">
                <label>{{ $t("Fødselsdato") }}</label>
                <input
                    :value="contact.birthdate"
                    @input="updateField('birthdate', $event.target.value)"
                    type="text"
                    placeholder="dd.mm.åååå"
                    class="form-control input"
                    :readonly="contact.isReadonly"
                />
            </div>

            <div class="form-group">
                <label>{{ $t("Relasjon til eleven") }}</label>
                <input :value="contact.relation"
                    @input="updateField('relation', $event.target.value)"
                    type="text" :placeholder="relationPlaceholder"
                    class="form-control input"
                />
            </div>

            <div class="form-group">
                <label>{{ $t("E-postadresse") }}</label>
                <input :value="contact.email"
                    @input="updateField('email', $event.target.value)"
                    type="email"
                    class="form-control input"/>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue'
    import wizardStore from '../../state/vippsWizardStore.js'

    const props = defineProps({
        contact: Object,
        index: Number
    })

    defineEmits(['remove'])

    const updateField = (field, value) => {
        wizardStore.updateContact(props.contact.id, field, value)
    }

    const relationPlaceholder = computed(() => {
        return $t('Foresatt')
    })
</script>